export default "__VITE_ASSET__BTOqyjGM__"